import { createSelector } from 'reselect';
import {
  getArmyList,
  getArmyListSize,
  getArmyListUnit,
  getArmyListUnitOptions,
  getArmyListUnits,
  getArmyOrganisation,
  getMagicItems,
  getMagicStandards,
  getModelRules,
  getUnit,
} from './unit/edit/selector/editSelector';
import { calculArmyListUnitMaxSize } from './calculArmyListUnitMaxSize';
import { ArmyListUnitEditView } from './view/ArmyListUnitEditView';
import { ArmyListUnitSizeEditView } from './view/ArmyListUnitSizeEditView';
import { armyListUnitCheckContraintsPresenter } from '@Selectors/builder/myArmyList/make/validation/army-list-unit-check-contraints.presenter';
import { optionGroupIsActive } from '@Selectors/builder/myArmyList/make/unit/edit/selector/optionGroupIsActive';
import { UnitOptionGroupView } from '@Selectors/builder/myArmyList/make/view/unit-option-group.view';
import { optionEditPresenter } from '@Selectors/builder/myArmyList/make/unit/edit/optionEditPresenter';

export const armyListUnitEditPresenter = createSelector(
  [
    getArmyList,
    getArmyListUnits,
    getArmyListUnit,
    getArmyOrganisation,
    getArmyListUnitOptions,
    getUnit,
    armyListUnitCheckContraintsPresenter,
    getArmyListSize,
    getModelRules,
    getMagicItems,
    getMagicStandards,
  ],
  (
    armyList,
    armyListUnits,
    armyListUnit,
    armyOrganisation,
    armyListUnitOptions,
    unit,
    warnings,
    armyListSize,
    modelRules,
    magicItems,
    magicStandards,
  ): ArmyListUnitEditView => {
    // Calcul avec les options qui peuvent limiter la taille de l'unité

    const warning = warnings.filter(
      (w) => armyListUnit?.id && w.armyListUnitIds.includes(armyListUnit.id),
    );

    const result: ArmyListUnitEditView = {
      armyListUnit: armyListUnit!,
      name: armyListUnit?.name ?? '',
      notes: armyListUnit?.notes ?? '',
      points: armyListUnit?.points ?? 0,
      size: {
        canChange: unit != null && unit.min_size != unit.max_size,
        current: armyListUnit?.size?.toString() ?? '',
        min: unit?.min_size ?? 0,
        max: unit?.max_size ?? 0,
        points: unit?.add_value_points ?? 0,
      } satisfies ArmyListUnitSizeEditView as ArmyListUnitSizeEditView,
      unitOptionGroups:
        armyList === null || armyListUnit === null
          ? []
          : (unit?.optionGroups ?? [])
              .filter((group) =>
                optionGroupIsActive(group, armyList, armyListUnit),
              )
              .map(
                (group) =>
                  ({
                    id: group.id,
                    name: group.name,
                    options: optionEditPresenter(
                      armyList,
                      armyListUnits,
                      armyListUnit.army_list_unit_unit_options,
                      armyListUnit,
                      modelRules,
                      magicItems,
                      magicStandards,
                      group,
                    ),
                  }) satisfies UnitOptionGroupView as UnitOptionGroupView,
              ),
      hasWarning: warning.length > 0,
      warning: warning,
    } satisfies ArmyListUnitEditView as ArmyListUnitEditView;

    if (!unit) return result;

    result.size.max = calculArmyListUnitMaxSize(
      unit,
      armyListUnit!,
      armyOrganisation!,
      armyListUnits,
      armyListUnitOptions,
      armyListSize,
    );
    return result;
  },
);
